import mutations from './documentLog.mutations'
import actions from './documentLog.actions'
import getters from './documentLog.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
